export const EMAIL_NODE_TYPES = ['send_email', 'send_ai_email'];

export const SCHEDULE_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const HOUR_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(h => ({ label: h, value: h }));

export const parseHourString = str => {
  if (!str) return { hour: 9, period: 'am' };
  const [time, period] = str.split(' ');
  return { hour: parseInt(time.split(':')[0], 10), period: period?.toLowerCase() || 'am' };
};

export const buildHourString = (hour, period) =>
  `${String(hour).padStart(2, '0')}:00 ${period.toUpperCase()}`;

export const formatDateForInput = dateStr => {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateForDisplay = isoStr => {
  if (!isoStr) return '';
  const d = new Date(isoStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const getDefaultTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'America/New_York';
  }
};

export const getDefaultStartingDate = () => {
  const today = new Date();
  return today.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const createDefaultEmailSchedule = (overrides = {}) => ({
  enabled: false,
  timezone: getDefaultTimezone(),
  timeFrom: '09:00 AM',
  timeTo: '04:00 PM',
  days: [],
  ...overrides,
});

export const getEmailScheduleFromNode = node => {
  const stored = node?.data?.emailSchedule;
  if (!stored || typeof stored !== 'object') {
    return createDefaultEmailSchedule();
  }
  return createDefaultEmailSchedule(stored);
};

export const isEmailNodeType = type => EMAIL_NODE_TYPES.includes(type);

export const isActiveEmailSchedule = schedule => {
  if (!schedule?.enabled) return false;
  const { timezone, timeFrom, timeTo, days } = schedule;
  return Boolean(timezone && timeFrom && timeTo && Array.isArray(days) && days.length > 0);
};
